import {createRouter, createWebHistory} from 'vue-router'
// import DailyBrief from '../views/DailyBriefView.vue'
import Sectors from '../views/SectorsView.vue'
import Calendars from "../views/CalendarsView";
import WatchlistProView from "../views/WatchlistProView";
import SymbolView from "../views/SymbolView";
import SearchView from "../views/SearchView";
import SocialTrend from "../views/SocialTrend";
import IndicesPartial from "../views/dailyBrief/IndicesPartial";
import ReadView from "../views/ReadView";
import FeedView from "../views/FeedView";
import TopTenPro from "../views/TopTenPro";
import IndexList from '../views/IndexList.vue';
import LockView from "../views/LockView";
import SettingsView from "../views/SettingsView";
import TopTrendingView from "../views/TopTrending";
import TradeView from "../views/TradeView";

import SignalsView from "../views/SignalsView";

const windowWidth = window.innerWidth;

const routes = [
    {
        path: '/',
        name: 'Home',
        components: {
            Side: windowWidth <= 660 ? FeedView : TopTenPro
        },
    },
    {
        path: '/settings',
        name: 'SettingsView',
        components: {
            Side: SettingsView
        },
    },
    {
        path: '/signals',
        name: 'SignalsView',
        components: {
            Side: SignalsView
        },
    },
    // {
    //     path: '/trades',
    //     name: 'Trades',
    //     components: {
    //         Side: TradesListView
    //     }
    // },
    // {
    //     path: '/sectorsflow',
    //     name: 'SectorFlow',
    //     components: {
    //         Side: SectorFlowView
    //     },
    //     children: [{
    //         path: '',
    //         name: 'SectorFlowTable',
    //         component: SectorFlowTable,
    //     },{
    //         path: '/sectorsflow/:symbol',
    //         name: 'SectorFlowAssets',
    //         component: SectorAssetsList,
    //     }]
    // },
    {
        path: '/lock',
        name: 'LockView',
        components: {
            Side: LockView
        },
    }, {
        path: '/toptrending',
        name: 'TopTrending',
        components: {
            Side: TopTrendingView
        },
    },
    {
        path: '/calendars',
        name: 'Calendars',
        components: {
            Side: Calendars
        },
    },
    {
        path: '/symbolPreview',
        name: 'symbolPreview',
        meta: {
            addHash: true
        }
    },
    {
        path: '/sectors',
        name: 'Sectors',
        components: {
            Side: Sectors
        },
    },
    {
        path: '/indices',
        name: 'Indices',
        components: {
            Side: IndicesPartial
        },
    },
    {
        path: '/trade/:tradeId',
        name: 'TradeView',
        components: {
            Side: TradeView
        },
    }, {
        path: '/movers',
        name: 'TopTenPro',
        components: {
            Side: TopTenPro
        },
    },
    {
        path: '/indices',
        name: 'Indices',
        components: {
            Side: IndexList
        },
    },
    {
        path: '/social',
        name: 'Social',
        components: {
            Side: SocialTrend
        },
    },
    {
        path: '/read/:link',
        name: 'Read',
        components: {
            Side: ReadView
        },
    },
    {
        path: '/devsymbol/:symbol',
        name: 'DevSymbol',
        components: {
            Side: SymbolView
        },
    },
    {
        path: '/symbol/:symbol',
        name: 'Symbol',
        components: {
            Side: SymbolView
        },
    },
    {
        path: '/feed/filtered/:feedId',
        name: 'FilteredFeed',
        components: {
            Side: FeedView
        },
    },
    {
        path: '/feed/sector/:symbol?',
        name: 'SectorFeed',
        components: {
            Side: FeedView
        },
    },
    {
        path: '/feed/:symbol?',
        name: 'Feed',
        components: {
            Side: FeedView
        },
    },
    {
        path: '/macro',
        name: 'Macro',
        components: {
            Side: FeedView
        },
    },
    // {
    //     path: '/dailyBrief',
    //     name: 'DailyBrief',
    //     components: {
    //         Side: DailyBrief
    //     },
    // },
    {
        path: '/search',
        name: 'Search',
        components: {
            Side: SearchView
        },
    },
    {
        path: '/watchlist',
        name: 'MyProWatchlist',
        components: {
            Side: WatchlistProView
        },
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

router.beforeEach((to, from, next) => {

    if (to.name && from.name && to.path === from.path) {
        return;
    }
    next();
});

export default router
